import type { BlockType } from "../types/models";

export const PRODUCT_NAME = "Интерактивные документы";

export const EXPORT_STATUS_LABELS: Record<string, string> = {
  pending: "В очереди",
  processing: "Обработка",
  completed: "Готов",
  failed: "Ошибка",
};

export const EXPORT_TYPE_LABELS: Record<string, string> = {
  html: "HTML",
  pdf: "PDF",
  docx: "DOCX",
};

export const BLOCK_TYPE_LABELS: Record<BlockType, string> = {
  heading: "Заголовок",
  paragraph: "Абзац",
  list: "Список",
  table_placeholder: "Таблица",
  image_placeholder: "Изображение",
  link_placeholder: "Ссылка",
  footnote_placeholder: "Сноска",
  attachment_placeholder: "Вложение",
  quote: "Цитата",
  page_break: "Разрыв страницы",
  section: "Раздел",
  custom_html: "Произвольный HTML",
};

export const ACTIVITY_ACTION_LABELS: Record<string, string> = {
  "document.parsing_started": "Начат разбор документа",
  "document.parsing_completed": "Разбор документа завершён",
  "document.extracting_assets": "Извлечение элементов",
  "document.assets_extracted": "Элементы извлечены",
  "document.creating_interactive_blocks": "Создание интерактивных блоков",
  "document.interactive_blocks_created": "Интерактивные блоки созданы",
  "document.processing_started": "Обработка документа запущена",
  "document.uploaded": "Документ загружен",
  "document.processed": "Документ обработан",
  "document.deleted": "Документ удалён",
  "document.html_exported": "Экспорт HTML",
  "document.pdf_exported": "Экспорт PDF",
  "export.html_queued": "HTML-экспорт поставлен в очередь",
  "export.pdf_queued": "PDF-экспорт поставлен в очередь",
  "block.updated": "Блок обновлён",
  "block.restored": "Блок восстановлен",
  "block.reordered": "Блоки переставлены",
  "block.converted_to_button": "Блок преобразован в кнопку",
  "asset.updated": "Элемент обновлён",
  "company.created": "Компания создана",
  "company.updated": "Компания обновлена",
  "company.deleted": "Компания удалена",
  "contact.received": "Получена заявка",
};

export function labelActivityAction(action: string): string {
  return ACTIVITY_ACTION_LABELS[action] ?? action.replaceAll(".", " · ");
}

export function labelBlockType(type: BlockType | string): string {
  return BLOCK_TYPE_LABELS[type as BlockType] ?? type;
}

export function labelExportStatus(status: string): string {
  return EXPORT_STATUS_LABELS[status] ?? status;
}
